const general = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome é obrigatório."
    },
    length: {
      maximum: 60,
      message: "Nome não pode ter mais de 60 caracteres."
    }
  },
  username: {
    presence: {
      allowEmpty: false,
      message: "E-mail é obrigatório."
    },
    email: {
      message: "E-mail não é válido."
    },
    length: {
      maximum: 100,
      message: "E-mail não pode ter mais de 100 caracteres."
    }
  },
  company_uuid: {
    presence: {
      allowEmpty: false,
      message: "Você deve selecionar uma empresa para o usuário."
    }
  }
};

const password = {
  password: {
    presence: {
      allowEmpty: false,
      message: "Senha é obrigatória."
    },
    length: {
      minimum: 8,
      message: "Senha deve ter no mínimo 8 caracteres."
    }
  },
  confirmPassword: {
    presence: {
      allowEmpty: false,
      message: "Confirmação de senha é obrigatória."
    },
    equality: {
      attribute: "password",
      message: "Confirmação de senha está diferente da senha."
    }
  }
};

const add = {
  ...general,
  ...password,
  permissions: {
    presence: {
      allowEmpty: false,
      message: "Ao menos uma permissão deve ser selecionada para o usuário."
    }
  }
};

const edit = {
  ...add,
  password: {
    length: {
      minimum: 8,
      message: "Senha deve ter no mínimo 8 caracteres."
    }
  },
  confirmPassword: {
    equality: {
      attribute: "password",
      message: "Confirmação de senha está diferente da senha."
    }
  }
};

export default {
  general,
  password,
  add,
  edit
};



// WEBPACK FOOTER //
// ./src/core/constraint/user.constraint.js